<template>
  <div
    class="popup-box flex flex-column"
    style="position: relative; padding: 10px"
  >
    <el-form
      :model="state.model"
      ref="formDom"
      style="width: 100%; margin-top: 10px"
    >
      <el-form-item label="自定义模板"
        ><el-switch
          v-model="state.model.salary_template_type"
          inline-prompt
          active-text="启用"
          inactive-text="禁用"
          :active-value="1"
          :inactive-value="0"
          :disabled="!$judge_auth('47')"
      /></el-form-item>
      <el-form-item label="模板字段">
        <div style="width: 100%">
          <ul style="display: flex; align-items: center">
            系统案例：<el-button
              v-for="item in state.fields"
              :key="item"
              type="primary"
              @click="
                state.model.fieldsArr?.includes(item)
                  ? ''
                  : state.model.fieldsArr.push(item)
              "
              size="small"
              style="
                display: flex;
                align-items: center;
                margin-right: 5px;
                width: fit-content;
              "
              :disabled="
                state.model.salary_template_type != 1 || !$judge_auth('47')
              "
            >
              <div style="display: flex; align-items: center">
                {{ item }}
                <el-icon color="#fff" size="14"><Plus /></el-icon>
              </div>
            </el-button>
            <el-button
              type="warning"
              @click="onAddOther()"
              size="small"
              style="
                display: flex;
                align-items: center;
                margin-right: 5px;
                width: fit-content;
              "
              :disabled="
                state.model.salary_template_type != 1 || !$judge_auth('47')
              "
            >
              <div style="display: flex; align-items: center">
                自定义字段
                <el-icon color="#fff" size="14"><Plus /></el-icon>
              </div>
            </el-button>
          </ul>
          <ul style="margin-top: 10px">
            已选字段：
            <transition-group class="container" name="sort">
              <el-tag
                v-for="(item, index) in state.model.fieldsArr"
                :key="item"
                :closable="state.model.salary_template_type == 1"
                type="primary"
                @close="state.model.fieldsArr.splice(index, 1)"
                style="margin-right: 10px; position: relative"
                :draggable="true"
                @dragstart="dragstart(item)"
                @dragenter="dragenter(item, $event)"
                @dragend="getDragend"
              >
                {{ item }}
                <!-- <div class="customer-tag-shade">
                  <el-icon color="#fff" size="70"><Back /></el-icon>
                  <li style="flex: 1"></li>
                  <el-icon color="#fff" size="40"><Right /></el-icon>
                </div> -->
              </el-tag>
            </transition-group>
          </ul>
          <ul style="display: flex; align-items: center">
            <el-icon color="#ffa500"><WarningFilled /></el-icon>
            <text style="color: #ffa500; font-size: 12px; margin-left: 3px">
              鼠标左键选中标签后可调整字段顺序
            </text>
          </ul>
        </div>
      </el-form-item>
      <el-form-item label=" " v-if="$judge_auth('47')">
        <el-button type="primary" @click="onSubmit">保存修改</el-button>
        <el-button type="warning" @click="onDownLoad">模板下载</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  customer_salarytemplate_info,
  customer_salarytemplate_save,
  customer_salarytemplate_download,
} from "@/http/customer";
import { post_response } from "@/utils/qFormat";
import { ElMessageBox, ElMessage } from "element-plus";

export default {
  props: {
    customer_id: Number,
    customer_name: String,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        fieldsArr: [],
      },
      fields: ["岗位工资", "补贴/津贴", "绩效/提成", "税前加项", "税前减项"],
    });

    onMounted(() => {
      if (props.customer_id) {
        customer_salarytemplate_info(props.customer_id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;

            if (state.model.fields) state.model.fieldsArr = state.model.fields;
            else state.model.fieldsArr = [];
          }
        });
      }
    });

    const onAddOther = () => {
      ElMessageBox.prompt("请填写字段名称", "添加自定义字段", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        inputValidator: (value) => {
          if (!value) return "请填写字段名称！";
          else {
            if (state.model.fieldsArr?.includes(value))
              return "字段已存在，请勿重复添加！";
          }
        },
      }).then(({ value }) => {
        state.model.fieldsArr.push(value);
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          state.model.fields = JSON.stringify(state.model.fieldsArr);
          state.model.customer_id = props.customer_id;
          customer_salarytemplate_save(state.model).then((res) => {
            post_response(res, emit);
          });
        }
      });
    };

    const onDownLoad = () => {
      customer_salarytemplate_download(props.customer_id)
        .then((res) => {
          let fileName = decodeURI(
            res.headers["content-disposition"].split("=")[1]
          );

          //通过后台返回 的word文件流设置文件名并下载
          var blob = new Blob([res.data], {
            type: res.data.type,
          });
          var downloadElement = document.createElement("a");
          var href = window.URL.createObjectURL(blob); //创建下载的链接
          downloadElement.href = href;
          downloadElement.download = fileName; //下载后文件名
          document.body.appendChild(downloadElement);
          downloadElement.click(); //点击下载
          document.body.removeChild(downloadElement); //下载完成移除元素
          window.URL.revokeObjectURL(href); //释放掉blob对象
        })
        .catch((err) => {
          const fileReader = new FileReader();
          fileReader.readAsText(
            new Blob([err.data], { type: "application/octet-stream" }),
            "utf-8"
          );
          fileReader.onload = () => {
            const msg = JSON.parse(fileReader.result);
            ElMessage.error(msg?.msg);
          };
        });
    };

    const dragstart = (value) => {
      state.oldData = value;
      state.dragStartId = value;
    };
    const dragenter = (value) => {
      state.newData = value;
      state.dragEndId = value;
    };
    const getDragend = () => {
      if (state.oldData !== state.newData) {
        let oldIndex = state.model.fieldsArr.indexOf(state.oldData);
        let newIndex = state.model.fieldsArr.indexOf(state.newData);
        let newItems = [...state.model.fieldsArr];
        // 删除之前DOM节点
        newItems.splice(oldIndex, 1);
        // 在拖拽结束目标位置增加新的DOM节点
        newItems.splice(newIndex, 0, state.oldData);
        // 每次拖拽结束后，将拖拽处理完成的数据，赋值原数组，使DOM视图更新，页面显示拖拽动画
        state.model.fieldsArr = newItems;
        // 每次拖拽结束后调用接口时时保存数据
      }
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      onAddOther,
      dragstart,
      dragenter,
      getDragend,
      onDownLoad,
    };
  },
};
</script>
<style scoped lang="less"></style>
